// extracted by mini-css-extract-plugin
module.exports = {"root":"ui_root__3fyWQ","item":"ui_item__3bLWX"};